import { SelectEventRequest } from '@core/models/cart/select-event-request.model';
import { AAGUID } from '@interticket/core';
import { Observable } from 'rxjs';
import { ICartCheckoutStatus } from './cart-checkout-status.interface';
import { ICart } from './cart.interface';
import { IDiscount } from './discount.interface';

export abstract class ICartSource {

  abstract getCart(): Observable<ICart>;
  abstract addToCart(selectEventRequest: SelectEventRequest): Observable<Response>;
  abstract getCartById(cartId: AAGUID): Observable<ICart>;
  abstract deleteCart(cartId: AAGUID): Observable<Response>;
  abstract deleteFromCart(selectionIds: AAGUID[]): Observable<Response>;
  abstract deleteGiftCardsToBuyFromCart(giftCardIds: AAGUID[]): Observable<Response>;
  abstract deleteGiftCard(couponId: AAGUID): Observable<Response>;
  abstract checkoutCart(paymentMethodId: AAGUID): Observable<Response>;
  abstract getCheckoutStatus(): Observable<ICartCheckoutStatus>;
  abstract getDiscount(couponId: string): Observable<IDiscount | null>;
  abstract applyDiscounts(cartItemId: AAGUID[], couponId: AAGUID): Observable<Response>;
  abstract removeDiscount(cartItemId: AAGUID): Observable<Response>;

}
